export default __webpack_public_path__ + "static/media/NORWAY.65a5160b.png";